/* Mega menu behaviour: hover / focus / touch open, Esc to close. */
if (!customElements.get('cbm-mega-menu')) {
  class CbmMegaMenu extends HTMLElement {
    connectedCallback() {
      this.current = null;
      this.closeTimer = null;
      this.hoverCapable = window.matchMedia('(hover: hover)');

      // Delegated listeners so they survive block re-renders in the theme editor.
      this.addEventListener('mouseover', (e) => {
        if (!this.hoverCapable.matches) return;
        const item = e.target.closest('.cbm-item');
        if (item && item.classList.contains('cbm-item--has-panel')) {
          this.open(item);
        } else {
          this.closeNow();
        }
      });

      this.addEventListener('mouseout', (e) => {
        if (!this.hoverCapable.matches) return;
        const item = e.target.closest('.cbm-item');
        if (item && !item.contains(e.relatedTarget)) this.scheduleClose();
      });

      this.addEventListener('focusin', (e) => {
        const item = e.target.closest('.cbm-item');
        if (item && item.classList.contains('cbm-item--has-panel')) this.open(item);
      });

      this.addEventListener('focusout', (e) => {
        if (!this.contains(e.relatedTarget)) this.scheduleClose();
      });

      // Touch devices: first tap opens the panel, second tap follows the link.
      this.addEventListener('click', (e) => {
        if (this.hoverCapable.matches) return;
        const link = e.target.closest('.cbm-item__link');
        const item = link && link.closest('.cbm-item--has-panel');
        if (item && !item.classList.contains('is-open')) {
          e.preventDefault();
          this.open(item);
        }
      });

      this.onKeydown = (e) => {
        if (e.key === 'Escape') this.closeNow();
      };
      this.onOutside = (e) => {
        if (!this.contains(e.target)) this.closeNow();
      };
      this.onReposition = () => {
        if (this.current) this.position(this.current);
      };

      document.addEventListener('keydown', this.onKeydown);
      document.addEventListener('pointerdown', this.onOutside);
      window.addEventListener('resize', this.onReposition);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('pointerdown', this.onOutside);
      window.removeEventListener('resize', this.onReposition);
    }

    // Stretch the panel to the full header width, directly under the header.
    position(item) {
      const panel = item.querySelector('.cbm-panel');
      if (!panel) return;
      const header = this.closest('header-component') || this.closest('header');
      if (!header) return;
      const anchor = panel.offsetParent || header;
      const h = header.getBoundingClientRect();
      const a = anchor.getBoundingClientRect();
      panel.style.top = h.bottom - a.top - anchor.clientTop + 'px';
      panel.style.left = h.left - a.left - anchor.clientLeft + 'px';
      panel.style.width = h.width + 'px';
    }

    open(item) {
      clearTimeout(this.closeTimer);
      if (this.current && this.current !== item) this.setState(this.current, false);
      this.current = item;
      this.position(item);
      this.setState(item, true);
    }

    scheduleClose() {
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => this.closeNow(), 140);
    }

    closeNow() {
      clearTimeout(this.closeTimer);
      if (this.current) this.setState(this.current, false);
      this.current = null;
    }

    setState(item, isOpen) {
      item.classList.toggle('is-open', isOpen);
      const link = item.querySelector('.cbm-item__link');
      if (link) link.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }
  }

  customElements.define('cbm-mega-menu', CbmMegaMenu);
}